const AVATAR_FONT_STYLES_RECORD = {
  xsmall: { fontSize: 10, fontWeight: 600 },
  small: { fontSize: 11, fontWeight: 600 },
  default: { fontSize: 13, fontWeight: 600 },
  large: { fontSize: 13, fontWeight: 700 },
  xlarge: { fontSize: 13, fontWeight: 700 }
};

export { AVATAR_FONT_STYLES_RECORD };
//# sourceMappingURL=font.mjs.map
